export const NotificationRowSkeleton = () => (
    <div className="flex flex-col gap-1.5 py-1.5 animate-pulse" data-testid="notification-row-skeleton">
        <div className="h-4 w-3/4 rounded bg-surface-light" />
        <div className="h-3 w-1/2 rounded bg-surface-light" />
    </div>
);
